<div class="parametre-donnees-champs-tab">
  <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
    <div>
      <h6 class="mb-0">Champs personnalisés</h6>
      <p class="mb-0 text-muted small">Liste ordonnée — les actions s’appliquent à chaque ligne.</p>
    </div>
    <button
      type="button"
      class="btn rippleEffect"
      style="background: rgba(19, 74, 211, 1); color: rgba(255, 255, 255, 1)"
      (click)="openAdd()"
    >
      <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Ajouter un champ
    </button>
  </div>

  <div class="parametre-donnees-dt-wrap parametre-donnees-champs-dt__table-shell mb-2">
    <div class="table-responsive">
      <table class="table table-hover parametre-donnees-champs-table pd-champs__table mb-0">
        <thead class="custom-header">
          <tr>
            <th style="width: 72px">Ordre</th>
            <th style="width: 120px">Code</th>
            <th>Libellé</th>
            <th style="width: 120px">Type</th>
            <th style="width: 120px">Groupe</th>
            <th style="width: 90px">Oblig.</th>
            <th style="width: 80px">Actif</th>
            <th>Utilisé dans</th>
            <th style="width: 120px" class="text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows; trackBy: trackById">
            <td>{{ row.ordre }}</td>
            <td><code class="small">{{ row.code }}</code></td>
            <td>{{ row.libelle }}</td>
            <td><span class="badge badge-success">{{ row.type }}</span></td>
            <td>{{ row.groupe }}</td>
            <td>
              <span class="text-success" *ngIf="row.obligatoire"><i class="bi bi-check-lg"></i></span>
              <span class="text-muted" *ngIf="!row.obligatoire">—</span>
            </td>
            <td>
              <span class="badge" [ngClass]="row.actif ? 'badge-success' : 'badge-secondary'">
                {{ row.actif ? 'Oui' : 'Non' }}
              </span>
            </td>
            <td class="small text-muted">{{ row.utiliseDans }}</td>
            <td class="text-right parametre-donnees-champs-actions">
              <div ngbDropdown container="body" placement="bottom-right" class="d-inline-block">
                <button
                  type="button"
                  class="btn "
                  ngbDropdownToggle
                  title="Actions"
                  [attr.aria-label]="'Actions pour ' + row.libelle"
                  [attr.id]="'pdChampsActions' + row.id"
                >
                  <span class="pd-champs-actions-trigger__inner" aria-hidden="true">
                    <i class="bi bi-three-dots-vertical"></i>
                  </span>
                </button>
                <div
                  ngbDropdownMenu
                  class="dropdown-menu-right pd-champs-actions-menu"
                  [attr.aria-labelledby]="'pdChampsActions' + row.id"
                >
                  <button ngbDropdownItem type="button" (click)="openEdit(row)">Modifier</button>
                  <button ngbDropdownItem type="button" (click)="duplicate(row)">Dupliquer</button>
                  <button ngbDropdownItem type="button" (click)="toggleActif(row)">
                    {{ row.actif ? 'Désactiver' : 'Activer' }}
                  </button>
                  <button ngbDropdownItem type="button" (click)="openUsages(row)">Voir usages</button>
                  <div class="dropdown-divider"></div>
                  <button ngbDropdownItem type="button" class="text-danger" (click)="delete(row)">Supprimer</button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="rows.length === 0" class="text-center text-muted py-4 small">Aucun champ défini.</div>
  </div>
</div>

<!-- Modal champ -->
<ng-template #champModalTpl let-modal>
  <div class="modal-header" style="background: transparent">

    <button type="button" class="close" aria-label="Fermer" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" *ngIf="editing" style="padding: 30px 64px 0">
      <h2 class="modal-title text-center">{{ isNew ? 'Ajouter un champ' : 'Modifier le champ' }}</h2>
    <div class="pd-section">
      <h6 class="pd-section__title">Général</h6>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Libellé <span class="text-danger">*</span></label>
          <input
            class="form-control"
            [(ngModel)]="editing.libelle"
            (ngModelChange)="onLibelleInput()"
            name="libelle"
            autocomplete="off"
          />
        </div>
        <div class="form-group col-md-6">
          <label>Code technique <span class="text-danger">*</span></label>
          <input
            class="form-control"
            [(ngModel)]="editing.code"
            (ngModelChange)="onCodeInput()"
            name="code"
            autocomplete="off"
          />
          <div *ngIf="codeError" class="text-danger small mt-1">{{ codeError }}</div>
        </div>
      </div>
      <div class="form-group">
        <label>Description</label>
        <textarea class="form-control" rows="2" [(ngModel)]="editing.description" name="desc"></textarea>
      </div>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label>Type de champ</label>
          <ng-select
            [items]="typeOptions"
            bindLabel="label"
            bindValue="value"
            [(ngModel)]="editing.type"
            (ngModelChange)="onTypeChange()"
            [clearable]="false"
            name="typeChamp"
            placeholder="Type"
          ></ng-select>
        </div>
        <div class="form-group col-md-4">
          <label>Groupe</label>
          <input class="form-control" [(ngModel)]="editing.groupe" name="groupe" />
        </div>
        <div class="form-group col-md-4">
          <label>Placeholder</label>
          <input class="form-control" [(ngModel)]="editing.placeholder" name="ph" />
        </div>
      </div>
      <div class="form-group">
        <label>Valeur par défaut</label>
        <input class="form-control" [(ngModel)]="editing.valeurParDefaut" name="def" />
      </div>
    </div>

    <div class="pd-section" *ngIf="showBlocListe() && editing.liste">
      <h6 class="pd-section__title">Paramètres du type — liste</h6>
      <div class="form-group">
        <label>Sélection</label>
        <select class="form-control" [(ngModel)]="editing.liste.monoOuMultiple" name="monoMulti">
          <option value="mono">Mono</option>
          <option value="multiple">Multiple</option>
        </select>
      </div>
      <label>Valeurs possibles</label>
      <div class="border rounded p-2 mb-2 pd-liste-valeurs-bloc">
        <div
          *ngFor="let lv of editing.liste.valeurs; let i = index"
          class="form-row align-items-end pd-liste-valeur-ligne"
          [class.pd-liste-valeur-ligne--sep]="i < editing.liste.valeurs.length - 1"
        >
          <div class="col-4">
            <input class="form-control form-control-sm" [(ngModel)]="lv.label" [name]="'lvL' + i" placeholder="Libellé" />
          </div>
          <div class="col-3">
            <input class="form-control form-control-sm" [(ngModel)]="lv.value" [name]="'lvV' + i" placeholder="Code" />
          </div>
          <div class="col-3">
            <input
              class="form-control form-control-sm"
              [(ngModel)]="lv.couleur"
              [name]="'lvC' + i"
              placeholder="# Couleur (optionnel)"
            />
          </div>
          <div class="col-2 text-right d-flex align-items-center justify-content-end">
            <button
              type="button"
              class="pd-btn-remove-liste-valeur"
              (click)="removeListeValeur(i)"
              [attr.aria-label]="'Retirer la ligne ' + (i + 1)"
            >
              <span class="pd-btn-remove-liste-valeur__icon" aria-hidden="true"></span>
            </button>
          </div>
        </div>
        <div
          class="pd-liste-valeurs-footer"
          [class.pt-2]="editing.liste.valeurs.length > 0"
          [class.mt-2]="editing.liste.valeurs.length > 0"
          [class.border-top]="editing.liste.valeurs.length > 0"
        >
          <b style="color: rgba(19, 74, 211, 1); cursor: pointer;" (click)="addListeValeur()">Ajouter une valeur</b>
        </div>
      </div>
    </div>

    <div class="pd-section" *ngIf="showBlocRelation() && editing.relation">
      <h6 class="pd-section__title">Paramètres du type — relation</h6>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label>Module cible</label>
          <select class="form-control" [(ngModel)]="editing.relation.moduleCible" name="modRel">
            <option *ngFor="let m of modulesRelation" [value]="m">{{ m }}</option>
          </select>
        </div>
        <div class="form-group col-md-6">
          <label>Type liaison</label>
          <select class="form-control" [(ngModel)]="editing.relation.typeLiaison" name="liaison">
            <option value="1-1">1 — 1</option>
            <option value="1-n">1 — n</option>
            <option value="n-n">n — n</option>
          </select>
        </div>
      </div>
    </div>

    <div class="pd-section" *ngIf="showBlocNombre() && editing.nombre">
      <h6 class="pd-section__title">Paramètres du type — nombre / devise / pourcentage</h6>
      <div class="form-row">
        <div class="form-group col-md-4">
          <label>Précision (décimales)</label>
          <input
            type="number"
            class="form-control"
            [(ngModel)]="editing.nombre.precision"
            name="prec"
            min="0"
            max="10"
          />
        </div>
        <div class="form-group col-md-4">
          <label>Minimum</label>
          <input type="number" class="form-control" [(ngModel)]="editing.nombre.minimum" name="min" />
        </div>
        <div class="form-group col-md-4">
          <label>Maximum</label>
          <input type="number" class="form-control" [(ngModel)]="editing.nombre.maximum" name="max" />
        </div>
      </div>
    </div>

    <div class="pd-section">
      <h6 class="pd-section__title">Contraintes</h6>
      <div class="d-flex flex-wrap gap-3">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="c-obl" [(ngModel)]="editing.obligatoire" name="obl" />
          <label class="custom-control-label checkmarg" for="c-obl">Obligatoire</label>
        </div>
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="c-uniq" [(ngModel)]="editing.unique" name="uniq" />
          <label class="custom-control-label checkmarg" for="c-uniq">Unique</label>
        </div>
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="c-lect" [(ngModel)]="editing.lectureSeule" name="ls" />
          <label class="custom-control-label checkmarg" for="c-lect">Lecture seule</label>
        </div>
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="c-act" [(ngModel)]="editing.actif" name="act" />
          <label class="custom-control-label" for="c-act">Actif</label>
        </div>
      </div>
    </div>

  </div>
    <div class=" justify-content-center p-0" style="display: flex;flex-wrap: wrap;align-items: center;justify-content: flex-end;margin-bottom: 64px;gap: 12px;margin-top: 12px">
        <button type="button" class="btn" style="background: rgba(128, 131, 144, 0.16)" (click)="modal.dismiss()">Annuler</button>
        <button type="button" class="btn btn-primary" (click)="saveChamp()">Enregistrer</button>
    </div>
</ng-template>

<!-- Modal usages -->
<ng-template #usagesModalTpl let-modal>
  <div class="modal-header" style="background: transparent">

    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body p-0" *ngIf="usagesField" style="margin: 30px 64px 64px">
      <h2 class="modal-title text-center">Usages — {{ usagesField?.libelle }}</h2>
    <p class="text-muted small mb-2">Exemples d’écrans où ce champ peut apparaître (données de démonstration).</p>
    <ul class="mb-0">
      <li>Fiche détail module</li>
      <li>Listes avec colonnes configurables</li>
      <li>Documents vente (devis, commande, BL, facture)</li>
      <li>Exports et rapports</li>
    </ul>
      <div class="justify-content-center" style="display: flex;flex-wrap: wrap;align-items: center;margin-top: 12px">
          <button type="button" class="btn btn-primary "  (click)="modal.close()">Fermer</button>

      </div>
  </div>

</ng-template>
